import React, { useState } from "react";
import Select from 'react-select'
import {
    format
} from "date-fns";

const createPackageSource = (baseUrl, source) => {

    return {
        requiresDeparture: true,
        getDepartures: async () => {
            const response = await fetch(`${baseUrl}/api/searchform/${source}`);
            const result = await response.json();
            return result;
        },
        getDestinations: async (departureAirports) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/searchform/${source}/${dep}`);
            const result = await response.json();
            return result;
        },
        getDestinationsWithTextSearch: async (departureAirports, text) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/searchform/${source}/${dep}/search?query=${text}`);
            const result = await response.json();
            return result;
        },
        getAvailableDates: async (departureAirports, destination) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/searchform/${source}/${dep}/${destination}`);
            const result = await response.json();
            return result;
        },
        getReturnDates: async (departureAirports, destination, date) => {
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/searchform/${source}/${dep}/${destination}/${format(date, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        },
        validate: async (departureAirports, destination, savedStartDate, savedToDate) => {
            if(destination === undefined){
                destination = "null";
            }
            var dep = departureAirports.join('-');
            const response = await fetch(`${baseUrl}/api/searchform/${source}/validate/${dep}/${destination}/${format(savedStartDate, "yyyy-MM-dd")}/${format(savedToDate, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        }
    }
}

// Hotel-only source: same method shapes as the package source so component call
// sites don't change — departure arguments are accepted and ignored, URLs carry
// no departures segment.
const createHotelSource = (baseUrl) => {

    return {
        requiresDeparture: false,
        getDepartures: async () => {
            return [];
        },
        getDestinations: async (departureAirports) => {
            const response = await fetch(`${baseUrl}/api/searchform/hotels`);
            const result = await response.json();
            return result;
        },
        getDestinationsWithTextSearch: async (departureAirports, text) => {
            const response = await fetch(`${baseUrl}/api/searchform/hotels/search?query=${text}`);
            const result = await response.json();
            return result;
        },
        getAvailableDates: async (departureAirports, destination) => {
            const response = await fetch(`${baseUrl}/api/searchform/hotels/${destination}`);
            const result = await response.json();
            return result;
        },
        getReturnDates: async (departureAirports, destination, date) => {
            const response = await fetch(`${baseUrl}/api/searchform/hotels/${destination}/${format(date, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        },
        validate: async (departureAirports, destination, savedStartDate, savedToDate) => {
            if(destination === undefined){
                destination = "null";
            }
            const response = await fetch(`${baseUrl}/api/searchform/hotels/validate/${destination}/${format(savedStartDate, "yyyy-MM-dd")}/${format(savedToDate, "yyyy-MM-dd")}`);
            const result = await response.json();
            return result;
        }
    }
}

const getDataSource = (source, baseUrl) => {

        if (source === "hotels") {
            return createHotelSource(baseUrl);
        }
        return createPackageSource(baseUrl, source);

}

export default { getDataSource };